export const saveOnlyNumbers = (value: string) => {
  return value.match(/\d/g)?.join('') || '';
};
